<template>
        <div class=" col-md-8 border-0 ">
            <div class="ibox dasboard_slides">
                <div class="ibox-title dashboard_title company-form-box-title pf-contribution">
                    <div class="clearfix">
                        <div class="left_container">
                            <ul class="title_list">
                                <li class="title-text">Payroll Run Status</li>
                            </ul>
                        </div>
                        <div class="right_container">
                            <div class="payroll-status-btn">
                                <b-button :href="pageurl+'/payruns/'"> Run Payroll</b-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ibox-content pt-0">
                    <carousel-3d :controls-visible="true" :count="payrun_status_data.length" id="payroll-carousel">
                        <slide v-for="(slides, i) in payrun_status_data" :index="i" :key="i" >
                            <template slot-scope="{ index, isCurrent}" >
                            <div class="slider_payrun" :data-index="index" :class="{current_new:isCurrent,approved:slides.is_approve==1,not_approved:slides.is_approve==0}" >
                                <div v-if="isCurrent==true">
                                    {{onCarChange(index)}}

                                </div>
                                <div  class="slider_payrun_top d-flex">
                                    <div class="left">
                                        <span class="payrun-month">
                                            {{slides.payrunmonth}}
                                        </span>
                                        <span class="payrun-year">
                                            {{slides.payrunyear}}
                                        </span>
                                    </div>
                                    <div class="right">
                                        <span class="eye">
                                            <svg width="31" height="21" viewBox="0 0 31 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M30.0206 10.4433C30.0206 10.4433 29.7404 11.0738 29.1688 11.9817C29.1688 11.9817 28.0425 13.7705 26.5516 15.2614C26.5516 15.2614 21.7416 20.0714 15.0536 20.0714C15.0536 20.0714 8.36556 20.0714 3.55555 15.2614C3.55555 15.2614 2.06465 13.7705 0.938357 11.9817C0.938357 11.9817 0.366725 11.0738 0.0864962 10.4433C-0.0288321 10.1838 -0.0288321 9.88761 0.0864963 9.62813C0.0864963 9.62813 0.366724 8.99761 0.938357 8.08973C0.938357 8.08973 2.06465 6.30091 3.55555 4.81001C3.55555 4.81001 8.36556 0 15.0536 0C15.0536 0 21.7416 0 26.5516 4.81001C26.5516 4.81001 28.0425 6.3009 29.1688 8.08973C29.1688 8.08973 29.7404 8.9976 30.0206 9.62813C30.136 9.88761 30.136 10.1838 30.0206 10.4433ZM27.4703 10.9123C27.4703 10.9123 27.7822 10.4169 27.9855 10.0357C27.9855 10.0357 27.7822 9.65452 27.4703 9.15916C27.4703 9.15916 26.464 7.56091 25.1323 6.22927C25.1323 6.22927 20.9102 2.00714 15.0536 2.00714C15.0536 2.00714 9.19694 2.00714 4.97481 6.22927C4.97481 6.22927 3.64317 7.56092 2.63687 9.15916C2.63687 9.15916 2.32498 9.65451 2.12166 10.0357C2.12166 10.0357 2.32498 10.4169 2.63687 10.9123C2.63687 10.9123 3.64317 12.5105 4.97481 13.8422C4.97481 13.8422 9.19694 18.0643 15.0536 18.0643C15.0536 18.0643 20.9102 18.0643 25.1323 13.8422C25.1323 13.8422 26.464 12.5105 27.4703 10.9123Z" fill="#1C1C1C"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M15.0536 4.01429C15.0536 4.01429 17.5477 4.01429 19.3114 5.77792C19.3114 5.77792 21.075 7.54156 21.075 10.0357C21.075 10.0357 21.075 12.5299 19.3114 14.2935C19.3114 14.2935 17.5477 16.0571 15.0536 16.0571C15.0536 16.0571 12.5594 16.0571 10.7958 14.2935C10.7958 14.2935 9.03214 12.5299 9.03214 10.0357C9.03214 10.0357 9.03214 7.54156 10.7958 5.77792C10.7958 5.77792 12.5594 4.01429 15.0536 4.01429ZM15.0536 6.02143C15.0536 6.02143 13.3908 6.02143 12.215 7.19719C12.215 7.19719 11.0393 8.37294 11.0393 10.0357C11.0393 10.0357 11.0393 11.6985 12.215 12.8742C12.215 12.8742 13.3908 14.05 15.0536 14.05C15.0536 14.05 16.7163 14.05 17.8921 12.8742C17.8921 12.8742 19.0679 11.6985 19.0679 10.0357C19.0679 10.0357 19.0679 8.37294 17.8921 7.19719C17.8921 7.19719 16.7163 6.02143 15.0536 6.02143Z" fill="#1C1C1C"/>
                                            </svg>
                                        </span>
                                    </div>

                                </div>
                                <div class="slider_payrun_middle d-flex">
                                    <div class="left">{{ getFormat(slides.gross_pay) }}</div>
                                    <div class="right">
                                        <template v-if="slides.change == 0 ">
                                            0 %
                                            <span class="percent-icon">
                                                <svg width="17" height="11" viewBox="0 0 17 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.12608 10.4637C0.869955 10.2178 0.861649 9.81089 1.10753 9.55477L5.42753 5.05477C5.54875 4.92849 5.71623 4.85711 5.89128 4.85711C6.06632 4.85711 6.2338 4.92849 6.35503 5.05477L8.97699 7.78598L12.0841 4.5494L9.8704 2.42424L16.9998 0.357108L15.2253 7.56496L13.0116 5.4398L9.44074 9.15945C9.31951 9.28573 9.15204 9.35711 8.97699 9.35711C8.80194 9.35711 8.63447 9.28573 8.51324 9.15945L5.89128 6.42824L2.03502 10.4452C1.78915 10.7013 1.3822 10.7096 1.12608 10.4637Z" fill="#069651"/>
                                                </svg>
                                            </span>

                                        </template>
                                        <template v-else-if="slides.change > 0 ">

                                            {{slides.change}} %
                                            <span  class="percent-icon">
                                                <svg width="17" height="11" viewBox="0 0 17 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.12608 10.4637C0.869955 10.2178 0.861649 9.81089 1.10753 9.55477L5.42753 5.05477C5.54875 4.92849 5.71623 4.85711 5.89128 4.85711C6.06632 4.85711 6.2338 4.92849 6.35503 5.05477L8.97699 7.78598L12.0841 4.5494L9.8704 2.42424L16.9998 0.357108L15.2253 7.56496L13.0116 5.4398L9.44074 9.15945C9.31951 9.28573 9.15204 9.35711 8.97699 9.35711C8.80194 9.35711 8.63447 9.28573 8.51324 9.15945L5.89128 6.42824L2.03502 10.4452C1.78915 10.7013 1.3822 10.7096 1.12608 10.4637Z" fill="#069651"/>
                                                </svg>
                                            </span>
                                        </template>
                                        <template v-else>

                                            {{slides.change}} %
                                            <span  class="percent-icon">
                                                <svg width="17" height="11" viewBox="0 0 17 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M16.8023 0.536287C17.0585 0.782163 17.0668 1.18911 16.8209 1.44523L12.5009 5.94523C12.3797 6.07151 12.2122 6.14289 12.0371 6.14289C11.8621 6.14289 11.6946 6.07151 11.5734 5.94523L8.95142 3.21402L5.8443 6.4506L8.058 8.57576L0.928558 10.6429L2.70309 3.43504L4.9168 5.5602L8.48767 1.84055C8.60889 1.71427 8.77637 1.64289 8.95142 1.64289C9.12646 1.64289 9.29394 1.71427 9.41517 1.84055L12.0371 4.57176L15.8934 0.554837C16.1393 0.298715 16.5462 0.29041 16.8023 0.536287Z" fill="#CC5057"/>
                                                </svg>
                                            </span>
                                        </template>
                                    </div>
                                </div>

                                <template  v-if="isCurrent==true">
                                    <div class="slider_payrun_bottom d-flex">
                                        <div class="sptrz-1">Run Date:</div> <div class="sptrz-2">{{slides.approve_date}}</div>
                                    </div>
                                    <div class="slider_payrun_bottom d-flex">
                                        <div class="sptrz-1">Gross Pay:</div> <div class="sptrz-2">{{formatMoney(slides.gross_pay)}}</div>
                                    </div>
                                    <div class="slider_payrun_bottom d-flex">
                                        <div class="sptrz-1">Deductions:</div> <div class="sptrz-2">{{formatMoney(slides.deduction)}}</div>
                                    </div>
                                    <div class="slider_payrun_bottom d-flex">
                                        <div class="sptrz-1">Total Pay:</div> <div class="sptrz-2">{{formatMoney(slides.total_pay)}}</div>
                                    </div>
                                </template>


                            </div>
                            </template>
                        </slide>
                    </carousel-3d>
                </div>
            </div>
        </div>
</template>


<script>


    import moment from 'moment';
    import { Carousel3d, Slide } from 'vue-carousel-3d';
    export default{

        props: ['pageurl'],

        components: {
            Carousel3d,
            Slide
        },
        data(){

            return {
                currentIndex:0,
                currentSlide:0,
                currentGross:0,
                currentDeduct:0,
                currentTotal:0,
                currentChange:0,
                datacollection: null,
                doughnutDatas: null,
                payrun_status_data: [],
                show_data:false,
            }
        },
        methods:{

            onCarChange(index)
            {
                this.currentGross = this.payrun_status_data[index].gross_pay;
                this.currentDeduct = this.payrun_status_data[index].deduction;
                this.currentTotal = this.payrun_status_data[index].total_pay;
                this.currentChange = this.payrun_status_data[index].change;
                //console.log(index);
            },
            getFormat(amount)
            {

                let hundred = Number(amount);
                hundred = hundred/1000;
                hundred = parseInt(hundred);
                if(hundred <= 0)
                {
                    return amount;
                }
                hundred = hundred + 'K';

                return hundred;

            },
            formatMoney: function(amount)
            {
                var money = Number(amount);
                money = money.toLocaleString();
                if(money=='NaN')
                money = amount;
                else{
                if(money.indexOf(".")<0)
                money = money+".00";
                }
                return money;
            },

            getPayrunStatusData()
            {

                if(!this.checkNet()) return false;
                let currentObj = this;
                let formData = new FormData();

                axios.post(this.pageurl+'/dashboard-payroll-run-status', formData)
                .then(function (response)
                {

                    if(response.data.length > 0)
                    {
                        this.payrun_status_data =response.data;
                    }
                    else
                    {
                        this.payrun_status_data = [];
                    }



                }.bind(this)).catch(function (error){currentObj.serverError(error);});


            },

        },
        created: function(){
            this.getPayrunStatusData();
             this.payrun_status_data =
                [   {
                    payrunmonth: 'June',payrunyear: '2022',is_approve: '1',approve_date: ''
                    }, {
                    payrunmonth: 'July',payrunyear: '2022',is_approve: '1',approve_date: ''
                    }, {
                    payrunmonth: 'August',payrunyear: '2022',is_approve: '1',approve_date: ''
                    }, {
                    payrunmonth: 'September',payrunyear: '2022',is_approve: '1',approve_date: ''
                    }, {
                    payrunmonth: 'October',payrunyear: '2022',is_approve: '1',approve_date: ''
                    }, {
                    payrunmonth: 'November',payrunyear: '2022',is_approve: '1',approve_date: ''
                    }, {
                    payrunmonth: 'December',payrunyear: '2022',is_approve: '1',approve_date: ''
                    },
                ];
        },
         computed: {
            currentTitle() {

            }
        }
    }

</script>

